import { useQueryParams } from '~/hooks/use-query-params/useQueryParams';
import { queryKeys, queryValues } from '~/routes/query-params';
import { POSTHOG_TRACKING_SOURCES } from '~/services/tracking/posthog/constants';
import { usePosthogEvents } from '~/services/tracking/posthog/use-posthog-events/usePosthogEvents';

export const useGeographicDrawer = () => {
  const { deleteQueryParam, setQueryParams, params } = useQueryParams();
  const { trackKgGeographyDrawerOpen } = usePosthogEvents();

  const isDrawerOpen =
    params[queryKeys.activeDrawer] === queryValues.geographicExposureDrawer;
  const countryCode = params[queryKeys.countryCode];
  const regionName = params[queryKeys.regionName];

  const openCountry = (code: string) => {
    trackKgGeographyDrawerOpen(
      POSTHOG_TRACKING_SOURCES.ASSET_OVERVIEW,
      'country'
    );
    setQueryParams({
      [queryKeys.activeDrawer]: queryValues.geographicExposureDrawer,
      [queryKeys.countryCode]: code,
      [queryKeys.regionName]: '',
    });
  };

  const openRegion = (name: string) => {
    trackKgGeographyDrawerOpen(
      POSTHOG_TRACKING_SOURCES.ASSET_OVERVIEW,
      'region'
    );
    setQueryParams({
      [queryKeys.activeDrawer]: queryValues.geographicExposureDrawer,
      [queryKeys.regionName]: name,
      [queryKeys.countryCode]: '',
    });
  };

  const closeDrawer = () =>
    deleteQueryParam([
      queryKeys.activeDrawer,
      queryKeys.countryCode,
      queryKeys.regionName,
    ]);

  const type = regionName ? 'region' : countryCode ? 'country' : null;

  return {
    closeDrawer,
    openCountry,
    openRegion,
    isDrawerOpen,
    countryCode,
    regionName,
    type,
  };
};
